<template>
  <div class="section-content">
    <div class="BM">
      <ul
        class="BM-tabs"
        v-if="tabs.length !== 0 && !hideNav"
      >
        <li
          v-for="(item, index) in tabs"
          :key="item.code"
          :class="{ 'is-active': activeTab === item.code }"
          class="BM-tabs-item"
          @click="openTab(item, index)"
        >
          <div class="BM-tabs-item-icon">
            <svg-icon :icon="item.icon"></svg-icon>
          </div>
          <div class="BM-tabs-item-text">{{ item.name }}</div>
        </li>
        <li
          class="BM-tabs-ink"
          :style="{ top: top + 'px' }"
        ></li>
      </ul>
      <div
        class="BM-content"
        id="business-center-container"
      >
        <transition
          name="fade-in-side"
          mode="out-in"
        >
          <components :is="activeTab" />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import ApplicationServiceManagement from "./pages/ApplicationService/index";
import ScheduleManagement from "./pages/ScheduleManagement";
import FlowInstance from "./pages/FlowInstance";
import PostManagement from "./pages/PostManagement";
import ContentRelease from "./pages/ContentRelease/index1";
import MessageServe from "./pages/MessgaeService/index";
// 引入加载远程组件函数
import {readDockerSettingAndLoadResource} from '@/utils/loadRemoteComponent';
import configR from '@/configs.js';
export default {
  name: "BusinessManagement",
  components: {
    ApplicationServiceManagement,
    ScheduleManagement,
    FlowInstance,
    PostManagement,
    MessageServe: ()=> readDockerSettingAndLoadResource(configR.envConfigs.REMOTE_MESSAGE_SETTING,MessageServe),
    ContentRelease,
  },
  data() {
    return {
      tabs: [],
      top: 0,
      hideNav: false,
      activeTab: '',
    };
  },
  created() {
    this.tabs = this.$store.state.user.businessManageNav;
    if(this.tabs.length >0) {
      let postManage = this.tabs.filter(tabsItem => {
       return  tabsItem.code === "PostManagement"
      })
      console.log('postManage', postManage);
      if(postManage && postManage.length === 0) {
        this.tabs.unshift({name:"岗位人员",code:"PostManagement",icon: "post-management"})
      }
    }
    this.activeTab = this.$route.params.activeTab || this.$route.query.activeTab || this.tabs[0].code || "ApplicationServiceManagement";
    if (this.tabs.length === 0) this.activeTab = "PostManagement";
    // 得到top值
      this.tabs.forEach((tabsItem, tabsIndex) => {
        if (tabsItem.code === this.activeTab) {
          this.top = tabsIndex * 98;
        }
      });
  },
  watch: {
    $route: {
      handler(value) {
        // 直接跳转到业务管理中心
        if (!value.params.activeTab && !value.query.activeTab) {
          this.hideNav = false;
          let index = this.top / 98;
          this.activeTab = this.tabs[index].code;
          return false;
        }
        this.activeTab = this.$route.params.activeTab || this.$route.query.activeTab;
        let judge = false;
        if (this.activeTab === "PostManagement") {
          this.tabs.forEach((tabsItem, tabsIndex) => {
            if (tabsItem.code === this.activeTab) {
              this.top = tabsIndex * 98;
              judge = true;
            }
          });
          if (judge) {
            return;
          }
          this.hideNav = true;
        }

        this.hideNav = true;
      },
      deep: true,
    },
  },
  methods: {
    openTab(tab, index) {
      this.top = index * 98;
      this.activeTab = tab.code;
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";
.section-content {
  width: 1680px;
  margin: 0 auto;
  @include portalMedia;
}
.BM {
  margin: 0 auto;
  width: 100%;
  display: flex;
  min-height: calc(100vh - 110px);
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;

  &-tabs {
    position: relative;
    width: 96px;
    background-color: $color-stripe;
    border-right: 1px solid rgba(230, 230, 230, 1);
    box-sizing: border-box;

    &-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 98px;
      cursor: pointer;
      box-sizing: border-box;

      &:hover,
      &.is-active {
        background-color: rgba($color: rgb(14, 108, 203), $alpha: 0.06);
        color: $color-primary;
        .svg-icon {
          //left: -30px;
        }

        .BM-tabs-item-text {
          color: $color-primary;
        }
      }

      &.is-active {
        .BM-tabs-item-text {
          color: $color-primary;
        }
      }
    }

    &-ink {
      position: absolute;
      width: 94px;
      height: 98px;
      background-color: rgba($color: rgb(14, 108, 203), $alpha: 0.06);
      border-right: 2px solid $color-primary;
      transition: all 0.3s;
    }

    &-item-icon {
      position: relative;
      width: 30px;
      height: 30px;
      overflow: hidden;

      .svg-icon {
        position: relative;
        width: 30px;
        height: 30px;
        //filter: drop-shadow(30px 0 $color-primary);
      }
    }

    &-item-text {
      margin-top: 10px;
      font-size: 12px;
      color: $color-text;
      line-height: 1;
    }
  }

  &-content {
    flex: 1;
    background-color: #fff;
    box-sizing: border-box;
    overflow-x: auto;
  }
}
</style>
